import { Component, forwardRef, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { AppConstants } from '@unpispas/upp-defs';
import { ViewModeDirective } from '../upp-grid/upp-grid';

@Component({
    selector: 'upp-thumb-top-left',
    template: `
        <ng-content></ng-content>
    `,
    styleUrls: []
})
export class UppThumbTopLeftComponent {
    // nothing to do
}

@Component({
    selector: 'upp-thumb-top-right',
    template: `
        <ng-content></ng-content>
    `,
    styleUrls: []
})
export class UppThumbTopRightComponent {
    // nothing to do
}

@Component({
    selector: 'upp-thumb-bottom',
    template: `
        <ng-content></ng-content>
    `,
    styleUrls: []
})
export class UppThumbBottomComponent {
    // nothing to do
}

@Component({
    selector: 'upp-thumb',
    providers: [{ 
        provide: ViewModeDirective, 
        useExisting: forwardRef(() => UppThumbComponent)  
    }],    
    templateUrl: './upp-thumb.html',
    styleUrls: ['./upp-thumb.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UppThumbComponent extends ViewModeDirective implements OnDestroy {
    @Input() title: string | null = null;
    @Input() color = 'medium';
    @Input() shape: 'default' | 'round' = 'default';
    @Input() wait = false;
    @Input() card: string | null = null;
    @Input() icon: string | null = null;
    @Input() foot: string | null = null;
    @Input() detail: string | null = null;
    @Input() press = false;

    private _pressed_timeout: ReturnType<typeof setTimeout> | null  = null;
    private _ignore_selected = false;

    constructor(private change: ChangeDetectorRef){
        super()
    }

    ngOnDestroy() {
        if (this._pressed_timeout) {
            clearTimeout(this._pressed_timeout);
            this._pressed_timeout = null;
        }
    }

    /**
     * Gets the current view mode.
     */ 
    override get viewMode(): 'GRID' | 'LIST' {
        return super.viewMode;
    }

    /**
     * Sets the view mode and updates child items if the value has changed.
     * @param value - The new view mode ('GRID' or 'LIST').
     */      
    override set viewMode(value: 'GRID' | 'LIST'){
        if (super.viewMode != value){
            super.viewMode = value;
            this.change.markForCheck();
        }
    }

    get avatar(): string | null {
        const _bg = 'd3c79b';
        const _fg = '000000';

        if (!this.title){
            return null;
        }

        return AppConstants.baseURL + 'photo/avatar?size=128&background=' + _bg + '&color=' + _fg + '&name=' + encodeURIComponent(this.title);
    }

    @Output() Pressed = new EventEmitter<void>();         
    async OnPressed(down: boolean){
        if (down){
            if (!this.press){
                return;     // this item is not suitable for log press functionality
            }

            if (this._pressed_timeout){
                clearTimeout(this._pressed_timeout);
                this._pressed_timeout = null;
            }

            this._pressed_timeout = setTimeout(() => {
                this.Pressed.emit();
                
                this._ignore_selected = true;
                setTimeout(() => {      // only ignore on current loop
                    this._ignore_selected = false;
                }, 0);
            }, 1000)
        }
        else {
            if (this._pressed_timeout){
                clearTimeout(this._pressed_timeout);
                this._pressed_timeout = null;
            }
        }
    }   

    @Output() Select = new EventEmitter<void>();         
    async OnSelect(){
        if (!this._ignore_selected){
            this.Select.emit();
        }
        this._ignore_selected = false;
    }
}